import React, { useState, useEffect } from "react";
import Form, { InputSection } from "../../components/Form";
import { Field, Formik } from "formik";
import { DropDown, DropDownOptionsProps } from "../../../../ui/DropDown";
import Input, { NumberInput } from "../../../../ui/Input";
import moment from "moment";
import { get } from "../../../../utils/get";
import numeral from "numeral";
interface IProps {
  values?: any;
  setFieldValue?: any;
}
const Allocation = ({ values, setFieldValue, ...props }: IProps) => {
  const allocationOptions = [
    {
      label: "monthly",
      value: "monthly",
    },
    {
      label: "quarterly",
      value: "quarterly",
    },
    {
      label: "annual",
      value: "annual",
    },
    {
      label: "biannual",
      value: "biannual",
    },
    {
      label: "prorata monthly",
      value: "prorata-monthly",
    },
    {
      label: "prorata quarterly",
      value: "prorata-quarterly",
    },
    {
      label: "prorata biannual",
      value: "prorata-biannual",
    },
    {
      label: "quarterly constant",
      value: "quarterly-constant",
    },
    {
      label: "monthly constant",
      value: "monthly-constant",
    },

    {
      label: "biannual constant",
      value: "biannual-constant",
    },
  ];

  useEffect(() => {
    if (get(values, "allocation.value") === "prorata-monthly") {
      moment.monthsShort().map((month) => {
        if (get(values, "target")) {
          const prorataTarget = (
            parseFloat(get(values, "target").replace(/,/g, "")) / 12
          ).toFixed(2);
          setFieldValue(month, numeral(prorataTarget).format("0,0.00"));
        }
      });
    } else if (get(values, "allocation.value") === "prorata-quarterly") {
      ["Q1", "Q2", "Q3", "Q4"].map((quarter) => {
        if (get(values, "target")) {
          const prorataTarget = (
            parseFloat(get(values, "target").replace(/,/g, "")) / 4
          ).toFixed(2);
          setFieldValue(quarter, numeral(prorataTarget).format("0,0.00"));
        }
      });
    } else if (get(values, "allocation.value") === "quarterly-constant") {
      ["Q1", "Q2", "Q3", "Q4"].map((quarter) => {
        if (get(values, "target")) {
          setFieldValue(quarter, get(values, "target"));
        }
      });
    } else if (get(values, "allocation.value") === "monthly-constant") {
      moment.monthsShort().map((month) => {
        if (get(values, "target")) {
          setFieldValue(month, get(values, "target"));
        }
      });
    } else if (get(values, "allocation.value") === "biannual-constant") {
      ["half1", "half2"].map((half) => {
        if (get(values, "target")) {
          setFieldValue(half, get(values, "target"));
        }
      });
    } else if (get(values, "allocation.value") === "prorata-biannual") {
      ["half1", "half2"].map((half) => {
        if (get(values, "target")) {
          const prorataTarget = (
            parseFloat(get(values, "target").replace(/,/g, "")) / 2
          ).toFixed(2);
          setFieldValue(half, numeral(prorataTarget).format("0,0.00"));
        }
      });
    }
    return () => {};
  }, [values, setFieldValue]);
  const Validate = (value) => {
    let error;

    if (!value) {
      error = "Value required";
    }

    return error;
  };
  return (
    <Form>
      <InputSection>
        <Field
          name="allocation"
          placeholder="select.."
          dropdownLabel="Allocation"
          validate={Validate}
          component={DropDown}
          width="16em"
          options={allocationOptions}
          isBordered={true}
          value={get(values, "allocation")}
        />
      </InputSection>
      {get(values, "allocation.value") === "monthly" ||
      get(values, "allocation.value") === "monthly-constant" ||
      get(values, "allocation.value") === "prorata-monthly" ? (
        <>
          <Field
            type="text"
            name="Jan"
            validate={Validate}
            placeholder="enter min value"
            label="Jan"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Feb"
            placeholder="enter min value"
            validate={Validate}
            label="Feb"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Mar"
            placeholder="enter min value"
            validate={Validate}
            label="Mar"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Apr"
            placeholder="enter min value"
            validate={Validate}
            label="Apr"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="May"
            placeholder="enter min value"
            validate={Validate}
            label="May"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Jun"
            placeholder="enter min value"
            validate={Validate}
            label="Jun"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Jul"
            placeholder="enter min value"
            validate={Validate}
            label="Jul"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Aug"
            placeholder="enter min value"
            validate={Validate}
            label="Aug"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Sep"
            placeholder="enter min value"
            validate={Validate}
            label="Sep"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Oct"
            placeholder="enter min value"
            validate={Validate}
            label="Oct"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Nov"
            placeholder="enter min value"
            validate={Validate}
            label="Nov"
            width="60%"
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Dec"
            placeholder="enter min value"
            label="Dec"
            validate={Validate}
            width="60%"
            component={NumberInput}
            isInline
          />
        </>
      ) : get(values, "allocation.value") === "quarterly" ||
        get(values, "allocation.value") === "quarterly-constant" ||
        get(values, "allocation.value") === "prorata-quarterly" ? (
        <>
          <Field
            type="text"
            name="Q1"
            placeholder="enter min value"
            label="Q1"
            validate={Validate}
            width="60%"
            value={values.Q1}
            component={NumberInput}
            isInline
          />
          <Field
            type="text"
            name="Q2"
            placeholder="enter min value"
            label="Q2"
            validate={Validate}
            width="60%"
            component={NumberInput}
            value={values.Q2}
            isInline
          />
          <Field
            type="text"
            name="Q3"
            placeholder="enter min value"
            label="Q3"
            validate={Validate}
            width="60%"
            component={NumberInput}
            value={values.Q3}
            isInline
          />
          <Field
            type="text"
            name="Q4"
            placeholder="enter min value"
            label="Q4"
            validate={Validate}
            width="60%"
            component={NumberInput}
            value={values.Q4}
            isInline
          />
        </>
      ) : get(values, "allocation.value") === "biannual" ||
        get(values, "allocation.value") === "biannual-constant" ||
        get(values, "allocation.value") === "prorata-biannual" ? (
        <>
          <Field
            type="text"
            name="half1"
            placeholder="enter  value"
            label="Half 1"
            validate={Validate}
            width="60%"
            component={NumberInput}
            value={values.half1}
            isInline
          />
          <Field
            name="half2"
            placeholder="enter  value"
            label="Half 2"
            validate={Validate}
            width="60%"
            component={NumberInput}
            value={values.half2}
            isInline
          />
        </>
      ) : get(values, "allocation.value") === "annual" ? (
        <Field
          type="text"
          name="target"
          placeholder="enter min value"
          validate={Validate}
          label="Target"
          width="60%"
          component={NumberInput}
          backgroundColor="#F5F6FB"
          value={values.target}
          disabled
        />
      ) : null}
    </Form>
  );
};

export default Allocation;
